import {createSelector} from 'reselect';

import {UserPageState, alertsSelectors} from './alertsSlice';

export const makeSelectAlertsByKey = (queryKey: string) =>
    createSelector(
        [
            (state: UserPageState) => state.userPage.tabs.content.alerts.queries[queryKey],
            (state: UserPageState) => alertsSelectors.selectEntities(state),
        ],
        (query, entities) => {
            if (!query) {
                return {items: [], total: 0, status: 'idle' as const, error: undefined};
            }
            return {
                items: (query.ids ?? []).map((id: string) => entities[id]!),
                total: query.total,
                status: query.status,
                error: query.error,
            };
        },
    );

export const selectReceivedAt = (state: UserPageState, queryKey: string) =>
    state.userPage.tabs.content.alerts.queries[queryKey]?.receivedAt;
